export default {
  loadingapp: true,
  longloader: {
    show: false,
    message: ""
  },
  errormessage: "",
  infomessage: "",

  user: undefined,
  userRole: undefined,

  nextSeqCode : {},
  globalContext: {
    pstatuses: {},
    projectVesselIds: {},
    projectId: null, 
    vesselId: null,
  },
  projectStatuses: [],
  projectVesselIds:[],
  projectVesselMappings:[],


  projectsNames: [],
  vesselNames: [],
  activityTypes: [],
  activityCategories: [],
  maxedCode: "",
  activityMaster: [],
  tools: [],
  vessels: [],
  projects:[],
  cables:[],
  macroActivities: [],
  soils:[],
  projectsInVessel: [],
  // project: {},
  activityConfigurations: [],
  trenchers: [],
  configurations: [],
  qhse: [],
  equipmentStatus: [],
  areas: [],
  vesselList: [],
  estimates: [],
  computers:[],
  projectsInComputer:[],
  dprOutputs:[],
};
